import service from '../../utils/service'
import Urls from '../../utils/urlStrings'
import { MICROSERVICES } from '../../utils/constants'

export class UserService {
  async getAllUsers(account_id, page, page_size, sort_by, sort_order) {
    try {
      const response = await service.get(Urls.getApiUrl(`admin/${account_id}/user/all`, MICROSERVICES.SESSIONMANAGER), {
        params: {
          page_no: page ? page - 1 : null,
          page_size: page_size ? page_size : null,
          sort_by: sort_by ? sort_by : null,
          ascending: sort_order === 'ascending',
        }
      })
      const { data } = response
      return data.data
    } catch (e) {
      throw e
    }
  }

  async addNewUser(params, account_id, method) {
    try {
      const response = await service[method](Urls.getApiUrl(`admin/${account_id}/user/${method === 'post' ? 'add' : 'update'}`, MICROSERVICES.SESSIONMANAGER), params)
      const { data } = response
      return data.data
    } catch (e) {
      throw e
    }
  }

  async resendInvite(account_id, email) {
    try {
      const response = await service.post(Urls.getApiUrl(`admin/${account_id}/user/resendinvite`, MICROSERVICES.SESSIONMANAGER), { email })
      const { data } = response
      return data.data
    } catch (e) {
      throw e
    }
  }
}

export const userService = new UserService()
